<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormPaquetehotel" role="form" method="post" autocomplete="off" onSubmit="return false">

					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div class="avatar-upload">
								<div class="avatar-edit">
									<input type="file" @change="$uploadImagePreview($event,ValidElement, Array('Img','imagePreview'))" id="file" name="file" ref="fileImg" accept=".png, .jpg, .jpeg">
									<label for="file"></label>
								</div>
								<div class="avatar-preview">
									<div id="imagePreview" :style="'background-image: url('+RutaFile+objPaquetehotel.Imagen+')'" :src="RutaFile+objPaquetehotel.Imagen">
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objPaquetehotel.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Precio">Precio</label>
							<input type="text" v-model="objPaquetehotel.Precio" class="form-control" id="Precio" placeholder="Ingresar Precio" readonly/>
							<CValidation v-if="this.errorvalidacion.Precio" :Mensaje="'*'+errorvalidacion.Precio[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Cantidad">Cantidad</label>
							<input type="text" v-model="objPaquetehotel.Cantidad" class="form-control" id="Cantidad" placeholder="Ingresar Cantidad" readonly/>
							<CValidation v-if="this.errorvalidacion.Cantidad" :Mensaje="'*'+errorvalidacion.Cantidad[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Descripcion">Descripción en español</label>
							<textarea id="Descripcion" placeholder="Ingresar Descripción en español" class="form-control" v-model="objPaquetehotel.Descripcion" cols="30" rows="4"></textarea>
							<CValidation v-if="this.errorvalidacion.Descripcion" :Mensaje="'*'+errorvalidacion.Descripcion[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="DescripcionIng">Descripción en Inglés</label>
							<textarea id="DescripcionIng" placeholder="Ingresar Descripción en Inglés" class="form-control" v-model="objPaquetehotel.DescripcionIng" cols="30" rows="4"></textarea>
							<CValidation v-if="this.errorvalidacion.DescripcionIng" :Mensaje="'*'+errorvalidacion.DescripcionIng[0]"/>
						</div>
					</div>
											
					<br>
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';

export default {
    name: 'FormPaquetehotel',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objPaquetehotel: {
				IdPaquete: 0,
				IdAgente: 0,
				Nombre: '',
				Precio: 0,
				Cantidad: 0,
				Descripcion: '',
				DescripcionIng: '',
				Imagen: '',
				UrlImagen: '',
				
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			ValidElement: Configs.validImage3m,
            RutaFile: '',
            Img: null,
        }
    },
    methods :
    {
       	async Guardar()
        {
			let formData = new FormData();
			let Imagen = this.$refs.fileImg.files[0];

            if(Imagen === undefined && this.objPaquetehotel.IdPaquete == 0){
                this.$toast.warning('Debe agregar una imagen');
                return false;
            }

			formData.set('IdPaquete', this.objPaquetehotel.IdPaquete);
			formData.set('IdAgente', this.objPaquetehotel.IdAgente);
			formData.set('Nombre', this.objPaquetehotel.Nombre);
			formData.set('Precio', this.objPaquetehotel.Precio);
			formData.set('Cantidad', this.objPaquetehotel.Cantidad);
			formData.set('Descripcion', this.objPaquetehotel.Descripcion);
			formData.set('DescripcionIng', this.objPaquetehotel.DescripcionIng);
			formData.set('TipoImagen','Paquetes');

			formData.set('ImagenAntigua', this.objPaquetehotel.Imagen);
			formData.append('Imagen',Imagen);

			this.errorvalidacion = [];
			this.poBtnSave.Toast = 0; 
			this.poBtnSave.DisableBtn = true;

			await this.$http.post('paqueteshotel', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "paqueteshotel/"+this.objPaquetehotel.IdPaquete
            ).then((res) => {
                this.objPaquetehotel = res.data.data;
				this.RutaFile = res.data.RutaFile;

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objPaquetehotel = {
				IdPaquete: 0,
				IdAgente: 0,
				Nombre: '',
				Precio: 0,
				Cantidad: 0,
				Descripcion: '',
				DescripcionIng: '',
				Imagen: '',
				UrlImagen: '',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();

			let ObjAgente = JSON.parse(sessionStorage.getItem('objAgente'));
			this.objPaquetehotel.IdAgente = ObjAgente.IdAgente;
                
            if (Id!='') 
            {
                this.objPaquetehotel.IdPaquete = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
